import React from 'react';
import { SxProps, Theme } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { CalculatedLine, MemberLine } from '@paragon/contract-library';

import { setReferenceLineType } from '../../../../store/actions/editorActions';
import { useAppDispatch } from '../../../hooks';

type RestrictedLine = Exclude<CalculatedLine, MemberLine>;

interface Props {
  line: RestrictedLine;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const displayValues: { [K in RestrictedLine['lineType']]: string } = {
  Absolute: 'Absolute',
  Parallel: 'Parallel',
  PointSlope: 'Point-Slope',
  PointToPoint: 'Point-to-Point',
  Perpendicular: 'Perpendicular',
  Division: 'Division',
};
const types = Object.keys(displayValues) as RestrictedLine['lineType'][];

const getDisplayValue = (type: keyof typeof displayValues) => displayValues[type];

export function ReferenceLineTypeProperty(props: Props) {
  const dispatch = useAppDispatch();

  const onChangeLineType = (newType: RestrictedLine['lineType']) => {
    dispatch(setReferenceLineType(props.line, newType));
  };

  return (
    <PropertySelectField
      sx={props.sx}
      property="Type"
      value={props.line.lineType}
      options={types}
      getName={getDisplayValue}
      submit={onChangeLineType}
      disabled={props.disabled}
    />
  );
}
